<h3>Key Terms</h3>
@if (!(keyTerms$ | async)?.length) {
  <h4>Coming Soon</h4>
}
@if (!useWordCloudKeyTerms) {
  <div [class.no-content]="!(keyTerms$ | async)?.length">
    @for (term of keyTerms$ | async; track term) {
      <span class="chip" [innerText]="term"></span>
    }
  </div>
}

@if (useWordCloudKeyTerms) {
  <div class="chart-container">
    <div class="chart-body">
      <aa-word-cloud
        [options]="wordCloudOptions"
        [data]="termsForCloud"
      ></aa-word-cloud>
    </div>
  </div>
}
